import React from 'react';
import PackCard from './PackCard';

const PackGrid = ({ packs, desktopCols = 5, onPreview, onDownload, onToggleFavorite }) => {
  if (!packs || !Array.isArray(packs)) return null;

  const gridMap = {
    4: 'md:grid-cols-4',
    5: 'md:grid-cols-5',
    6: 'md:grid-cols-6',
    7: 'md:grid-cols-7',
    8: 'md:grid-cols-8'
  };

  const desktopClass = gridMap[desktopCols] || 'md:grid-cols-5';

  return (
    <div className={`grid grid-cols-2 ${desktopClass} gap-3 md:gap-5 w-full`}>
      {packs.map((pack) => (
        <PackCard
          key={pack.id}
          pack={pack}
          onPreview={onPreview}
          onDownload={onDownload}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
};

export default PackGrid;
